import { ButtonBase, makeStyles, Tooltip, Typography } from "@material-ui/core";
import classNames from "classnames";
import { format, isToday } from "date-fns";
import { sv } from "date-fns/locale";
import i18next from "i18next";
import React from "react";
import { useTranslation } from "react-i18next";
import { KvixIcon } from "../../icons";
const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        minWidth: 100,
        borderRadius: 0,
        border: "1px solid",
        backgroundColor: (props) => {
            if (theme.palette.type === "dark") {
                return props.selected ? "#cf26605c" : theme.palette.background.paper;
            }
            return props.selected ? "#FEE9EE" : "#FFFFFF";
        },
        borderColor: (props) => {
            if (theme.palette.type === "dark") {
                return props.selected ? theme.palette.primary.main : "transparent";
            }
            return props.selected ? "transparent" : theme.palette.primary.main;
        },
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        transition: "all ease 0.2s",
        padding: "4px 8px 4px 8px"
    },
    disabled: {
        filter: "grayscale(1)",
        opacity: 0.7
    },
    day: {
        fontSize: 14,
        fontWeight: 500,
        textAlign: "left"
    },
    time: {
        fontSize: 14,
        fontWeight: 700,
        textAlign: "left"
    },
    ripple: {
        color: theme.palette.primary.light
    },
    icon: {
        transition: "all ease 0.2s",
        borderRadius: "50%"
    },
    iconDisabled: {
        color: "transparent",
        backgroundColor: "rgba(0, 0, 0, 0.1)",
        transform: "scale(0.8)"
    }
}));
export const SelectableDate = (props) => {
    const classes = useStyles(props);
    const date = new Date(props.date);
    const weekDay = format(date, "iii", {
        locale: i18next.language === "sv-SE" && sv
    });
    const time = format(date, "HH:mm", {
        locale: i18next.language === "sv-SE" && sv
    });
    const today = isToday(date);
    const dayAndMonth = `${date.getDate()} ${format(date, "MMM", {
        locale: i18next.language === "sv-SE" && sv
    })}`;
    const { t } = useTranslation("general");
    const buttonClasses = classNames(classes.root, {
        [classes.disabled]: props.disabled
    });
    const iconClasses = classNames(classes.icon, {
        [classes.iconDisabled]: !props.selected
    });
    const click = () => {
        var _a;
        if (!props.cancelable) {
            (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props);
        }
    };
    return (React.createElement(ButtonBase, { className: buttonClasses, disabled: props.disabled, TouchRippleProps: { className: classes.ripple }, onClick: click },
        React.createElement("div", null,
            React.createElement(Typography, { color: "primary", className: classes.day }, today ? t("today") : `${weekDay} ${dayAndMonth}`),
            React.createElement(Typography, { color: "primary", className: classes.time }, time)),
        props.cancelable ? (React.createElement(Tooltip, { title: props.cancelTooltip || "", arrow: true, placement: "top" },
            React.createElement(KvixIcon.Close, { color: "primary", className: iconClasses, onClick: props.onCancelClick }))) : (React.createElement(KvixIcon.Checkmark.Circled, { color: "primary", className: iconClasses }))));
};
//# sourceMappingURL=SelectableDate.js.map